import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { HistoryAndDiagnosesQuestionnaireItem } from './questionnaire'

// History and Diagnoses subsection questionnaire answer type mapping
export const HISTORY_AND_DIAGNOSES_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_PRIMARY_DIAGNOSES]:
    QuestionnaireAnswerType.CODING,
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_OTHER_DIAGNOSES]:
    QuestionnaireAnswerType.CODING,
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_THERAPIES]:
    QuestionnaireAnswerType.CODING,
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_EQUIPMENT]:
    QuestionnaireAnswerType.CODING,
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_EQUIPMENT_OTHER]:
    QuestionnaireAnswerType.STRING,
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_PCP]: QuestionnaireAnswerType.CODING,
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_ER_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_ER_NOTES]:
    QuestionnaireAnswerType.STRING,
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_HOSPITAL_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_HOSPITAL_NOTES]:
    QuestionnaireAnswerType.STRING,
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_INJURIES_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_INJURIES_NOTES]:
    QuestionnaireAnswerType.STRING,
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_FALLS_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_FALLS_NOTES]:
    QuestionnaireAnswerType.STRING,
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_INFECTIONS_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_INFECTIONS_NOTES]:
    QuestionnaireAnswerType.STRING,
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_MD_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [HistoryAndDiagnosesQuestionnaireItem.HISTORY_AND_DIAGNOSES_MD_NOTES]:
    QuestionnaireAnswerType.STRING
}
